const Spinner = ({ className = '', size = 'sm' }: { className?: string; size?: 'sm' | 'lg' }) => {
  return <div className={`iLendingCDX-spinner ${className} iLendingCDX-spinner--${size}`}></div>;
};

export default Spinner;
